import { WANTABLE_API_BASE_URL } from "@wantable/Config";
import { handleErrorResponse } from "../helpers/handleErrorResponse";
import { cacheShopifyToken, cacheUserData } from "@wantable/Shared";

export const loginToWantableWithSocialmediaToken = async (
  socialMediaAccessToken: string,
  socialMedia: "facebook" | "google"
) => {

  const requestBody = socialMedia === "facebook"
    ? {
      access_token: socialMediaAccessToken,
    }
    : socialMedia === "google" ? {
      id_token: socialMediaAccessToken,
    } : {};

  const response = await fetch(
    `${WANTABLE_API_BASE_URL}/users/${socialMedia}_authenticate`,
    {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    await handleErrorResponse(response);
  }

  const result: any = await response.json();
  const token = result.data.attributes.shopify_multipass_token.token;


  let redirect = window.location.pathname;
  if(redirect.startsWith('/account/login') || redirect.startsWith('/account/register')){
    // go to homepage instead of login/signup/
    redirect = '/';
  }

  cacheUserData(result);
  cacheShopifyToken(result);

  window.location.href = `https://${window.location.hostname}/account/login/multipass/${token}?return_to=${redirect}`;
};
